module.exports = __webpack_public_path__ + "static/img/20ok.73fd4a18.webp";